export default __webpack_public_path__ + "static/media/BrainBreak cards97.86339b1b.png";